export const CREATE_STAFF_USER_REQUEST = "CREATE_STAFF_USER_REQUEST";
export const CREATE_STAFF_USER_SUCCESS = "CREATE_STAFF_USER_SUCCESS";
export const CREATE_STAFF_USER_FAILURE = "CREATE_STAFF_USER_FAILURE";

export const GET_STAFF_USER_REQUEST = "GET_STAFF_USER_REQUEST";
export const GET_STAFF_USER_SUCCESS = "GET_STAFF_USER_SUCCESS";
export const GET_STAFF_USER_FAILURE = "GET_STAFF_USER_FAILURE";
